import { ReactElement } from "react";
import { ElementProps } from "../../functionalComponents/RenderPage";

// The `language:` directive renders nothing — it's read by the DeckLanguage
// selector and applied to the document/content root's lang attribute (WCAG
// 3.1.1) in Display.tsx.
const Language = function ({}: ElementProps): ReactElement<ElementProps> {
	return <></>;
};

export default Language;
